import React from 'react';
import { ListItem, ListItemContent, Box } from "@mui/joy";
import { Button } from '../Button';

import { Tag, PersonAvatar } from '../Snippet';
import { useTranslation } from 'react-i18next'
import { useFormatter } from '../../utils';
import { Icon } from 'src/mtska-frontend-app-component/assets';

import JSONPretty from 'react-json-pretty';

const RelationshipRulesetWithDeal = ({ k, v, editing, detailInspector = true, handleItemDetail, handleItemRemove, loadingDissociation }) => {
    const { t, i18n } = useTranslation();
    const { formatDate } = useFormatter();

    const tagcolors = {
        active: "success",
        terminated: "warning",
        future: "secondary",
        missing_timeframe: "danger"
    }

    return (
        <>
            <ListItem key={k} variant="outlined" className={"relationship-element"}>
                <ListItemContent sx={{ display: 'flex' }} className={"relationship-element-content"}>
                    <Box className={"coupled"}>
                        <Box className="value production">
                            {v?.production}
                        </Box>
                    </Box>
                    <Box className={"coupled"}>
                        <Box className="label">{v?.revenueDeal?.partner?.name} | {v?.revenueDeal?.name}</Box>
                        <Box className="value">
                            {formatDate(v?.revenueDeal?.start_at)} - {formatDate(v?.revenueDeal?.end_at)}
                        </Box>
                    </Box>
                    {
                        v?.revenueRules[0] &&
                        <Box className={"tripled"}>
                            <Box className="label" title={t(v?.revenueRules[0]?.field)}>{t((v?.revenueRules[0]?.field ?? '').replace('_related_', '').replace('_readable', '').replace('_numeric', ''))}</Box>
                            <Box className="label operator">{t(v?.revenueRules[0]?.operator)}</Box>
                            <Box className="label">{v?.revenueRules[0]?.value}</Box>
                        </Box>
                    }
                    {
                        v?.revenueRules[1] &&
                        <Box className={"tripled"}>
                            <Box className="label" title={t(v?.revenueRules[1]?.field)}>{t((v?.revenueRules[1]?.field ?? '').replace('_related_', '').replace('_readable', '').replace('_numeric', ''))}</Box>
                            <Box className="label operator">{t(v?.revenueRules[1]?.operator)}</Box>
                            <Box className="label">{v?.revenueRules[1]?.value}</Box>
                        </Box>
                    }
                    {
                        v?.revenueRules[2] &&
                        <Box className={"tripled"}>
                            <Box className="label" title={t(v?.revenueRules[2]?.field)}>{t((v?.revenueRules[2]?.field ?? '').replace('_related_', '').replace('_readable', '').replace('_numeric', ''))}</Box>
                            <Box className="label operator">{t(v?.revenueRules[2]?.operator)}</Box>
                            <Box className="label">{v?.revenueRules[2]?.value}</Box>
                        </Box>
                    }
                    {
                        v?.revenueRules[3] &&
                        <Box className={"tripled"}>
                            <Box className="label" title={t(v?.revenueRules[3]?.field)}>{t((v?.revenueRules[3]?.field ?? '').replace('_related_', '').replace('_readable', '').replace('_numeric', ''))}</Box>
                            <Box className="label operator">{t(v?.revenueRules[3]?.operator)}</Box>
                            <Box className="label">{v?.revenueRules[3]?.value}</Box>
                        </Box>
                    }
                    {
                        v?.revenueRules[4] &&
                        <Box className={"tripled"}>
                            <Box className="label" title={t(v?.revenueRules[4]?.field)}>{t((v?.revenueRules[4]?.field ?? '').replace('_related_', '').replace('_readable', '').replace('_numeric', ''))}</Box>
                            <Box className="labe operatorl">{t(v?.revenueRules[4]?.operator)}</Box>
                            <Box className="label">{v?.revenueRules[4]?.value}</Box>
                        </Box>
                    } 
                </ListItemContent>
                {editing && handleItemDetail && detailInspector && (<Button onClick={() => handleItemDetail(v)} icon="faPen" variant="plain" />)}
                {(editing && handleItemRemove) && (<Button onClick={() => handleItemRemove(v)} icon="faClose" variant="plain" loading={loadingDissociation} />)}
            </ListItem>
        </>
    )
}

export default RelationshipRulesetWithDeal;



